




import { pageFactory } from '@/main/pages/pageFactory';
import { pageStoreBuilder } from '@/main/store/pages/page/builder';

const name = 'ArchyvDokladuListIframe';

export default pageFactory(name, pageStoreBuilder({
	name,
	crumbLabel: 'NV_ArchivDokl',
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
}));
